import { Type } from 'class-transformer';

import { PWUtils } from '../shared';

export class BaseModel {
  id: number;

  @Type(PWUtils.classType(Date))
  modifiedAt: Date;

  @Type(PWUtils.classType(Date))
  createdAt: Date;
}
